/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const UngroupIcon = ({ width = 24, height = 24, hidden = false, title = 'Ungroup' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <g>
      <path d="M9.123 4H31.36v22.237l2 2V3a1 1 0 0 0-1-1H7.123Z" />
      <rect
        x="16.132"
        y="-3.927"
        width="2.455"
        height="43.854"
        rx=".818"
        transform="rotate(-45 17.36 18)"
      />
      <path
        d="M6.36 16h4.5l-5.5-5.5V15a1 1 0 0 0 1 1ZM14.36 6.034H9.991L15.36 11.4V7.034a1 1 0 0 0-1-1ZM8.36 30h8a1 1 0 0 0 1-1v-6.5l-2.5-2.5h-6.5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1ZM29.36 21v-8a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v2.356L26 22h2.36a1 1 0 0 0 1-1Z"
      />
      <path d="M25.731 32H3.36V9.628l-2-2V33a1 1 0 0 0 1 1h25.371Z" />
    </g>
  </svg>`;
};
